import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row, Form } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import Download from '../../MainSection/Download/Download';
import { useDispatch, useSelector } from 'react-redux';
import { loadLotSizeDatas, loadSingleLotSizeDatas, loadZoneMasterDatas } from '../../../redux/action';
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import SbCancelBtn, { SbFilterBtn } from '../../Buttons/Buttons';
import ViewLotSizeModal from './ViewLotSizeModal';
import LotSizeBulkUploadModal from './LotSizeBulkUploadModal';
import AddLotSize from './AddLotSize';
import LotSizeTable from './LotSizeTable';
import { useLocation } from 'react-router-dom';
import searchIcon from '../../../assets/images/Dashboard/search-icon.svg'
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import { Document, Packer, Table, TableRow, TableCell, Paragraph } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';
import LotSizeColumnFilterModal from './LotSizeColumnFilterModal';

const LotSize = () => {
    let dispatch = useDispatch();
    let location = useLocation();

    const { lotSizeData, totalDataCount, singleLotSizeData } = useSelector((state) => state.data);
    console.log(singleLotSizeData, 'singleLotSizeData')
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

    const [moduleData, setModuleData] = useState(null);

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Find the module data using the moduleId
            const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
            setModuleData(module);
        }
    }, [storedModulePermissions, moduleId]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showViewDetails, setShowViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);

    const [selectedColumns, setSelectedColumns] = useState([
        "LOT SIZE PROCEDURE", "LS", "LI", "Pds", "LLP", "LLI", "Lper", "DESCRIPTION", "ACTION"
    ]);
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [lotSizeID, setLotSizeID] = useState("");

    const lotSizeDatas = () => {
        dispatch(loadLotSizeDatas(setLoading, rowsPerPage, page + 1, searchQuery));
    }
    useEffect(() => {
        lotSizeDatas();
    }, [page, rowsPerPage, searchQuery]);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    const handleOpenModal = (lotSizeId) => {
        setIsModalOpen(true);
        if (lotSizeId) {
            dispatch(loadSingleLotSizeDatas(lotSizeId));
            setLotSizeID(lotSizeId);
        } else {
            setLotSizeID("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleOpenViewModal = (lotSizeId) => {
        setShowViewDetails(!showViewDetails);
        if (lotSizeId) {
            dispatch(loadSingleLotSizeDatas(lotSizeId));
            setLotSizeID(lotSizeId);
        } else {
            setLotSizeID("");
        }
    }

    const handleCloseViewModal = () => {
        setShowViewDetails(false)
    }

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    }

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        // Prepare data to be written to Excel (complainEscalationData)
        const dataToExport = lotSizeData?.map(item => ({
            "LOT SIZE PROCEDURE": item.LotSizeProcedure || "NA",
            "LS": item.LS || "NA",
            "LI": item.LI || "NA",
            "Pds": item.PDS || "NA",
            "LLP": item.LLP || "NA",
            "LLI": item.LLI || "NA",
            "LPER": item.LPER || "NA",
            "DESCRIPTION": item.Description || "NA",
        })) || [];

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Lot Size");

        // Generate Excel file and trigger the download
        XLSX.writeFile(wb, 'lotSize.xlsx');
    };

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' }); // Landscape for more width

        // Title
        doc.setFontSize(18);
        doc.text("Lot Size Data", 14, 20);

        const dataToExport = lotSizeData?.map(item => ([
            item.LotSizeProcedure || "NA",
            item.LS || "NA",
            item.LI || "NA",
            item.PDS || "NA",
            item.LLP || "NA",
            item.LLI || "NA",
            item.LPER || "NA",
            item.Description || "NA",
        ])) || [];

        const columns = [
            { title: "LOT SIZE PROCEDURE", dataKey: "LotSizeProcedure" },
            { title: "LS", dataKey: "LS" },
            { title: "LI", dataKey: "LI" },
            { title: "Pds", dataKey: "PDS" },
            { title: "LLP", dataKey: "LLP" },
            { title: "LLI", dataKey: "LLI" },
            { title: "Lper", dataKey: "LPER" },
            { title: "DESCRIPTION", dataKey: "Description" },
        ];

        // Generate table
        doc.autoTable({
            head: [columns],
            body: dataToExport,
            startY: 30,
            tableWidth: 'auto', // Auto-adjust table to fit page
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak',
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: [255, 255, 255],
                halign: 'left',
            },
        });

        // Save PDF
        doc.save('lot_size.pdf');
    };

    const handleDownloadWord = () => {
        if (!lotSizeData || lotSizeData.length === 0) {
            console.error("No data available for export.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the Word document
        const dataToExport = lotSizeData.map(item => [
            String(item?.LotSizeProcedure || "NA"),  // Explicitly convert to string
            String(item?.LS || "NA"),  // Explicitly convert to string
            String(item?.LI || "NA"),  // Explicitly convert to string
            String(item?.PDS || "NA"),  // Explicitly convert to string
            String(item?.LLP || "NA"),  // Explicitly convert to string
            String(item?.LLI || "NA"),  // Explicitly convert to string
            String(item?.LPER || "NA"),  // Explicitly convert to string
            String(item?.DESCRIPTION || "NA"),  // Explicitly convert to string
        ]);

        // Define the headers for the table in the Word document
        const headers = [
            "LOT SIZE PROCEDURE", "LS", "LI", "Pds", "LLP", "LLI", "Lper", "DESCRIPTION",
        ];

        // Create table rows for the document
        const tableRows = [
            // Header Row
            new TableRow({
                children: headers.map(header => new TableCell({ children: [new Paragraph(header)] }))
            }),
            // Data Rows
            ...dataToExport.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        // Create the table
        const table = new Table({
            rows: tableRows
        });

        // Create the document with metadata
        const doc = new Document({
            creator: "Standards Master",
            title: "Lot Size Report",
            description: "A detailed report of Lot Size.",
            sections: [  // Ensure that sections are properly passed as an array
                {
                    children: [table]
                }
            ]
        });

        // Generate and download the Word document
        Packer.toBlob(doc)
            .then(blob => saveAs(blob, "lot_size.docx"))
            .catch(error => {
                console.error("Error generating Word document:", error);
                alert("An error occurred while generating the Word document. Check the console for details.");
            });
    };

    const handlePrint = () => {
        if (!lotSizeData || lotSizeData.length === 0) {
            console.error("No data available for printing.");
            alert("No data to print!");
            return;
        }

        const dataToExport = lotSizeData?.map(item => ([
            item.LotSizeProcedure || "NA",
            item.LS || "NA",
            item.LI || "NA",
            item.PDS || "NA",
            item.LLP || "NA",
            item.LLI || "NA",
            item.LPER || "NA",
            item.Description || "NA",
        ])) || [];

        const headers = [
            "LOT SIZE PROCEDURE", "LS", "LI", "Pds", "LLP", "LLI", "Lper", "DESCRIPTION",
        ];

        // Create HTML table for printing
        let tableHtml = `
                    <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                        <thead>
                            <tr>
                                ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                            </tr>
                        </thead>
                        <tbody>
                            ${dataToExport.map(row => `
                                <tr>
                                    ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                `;

        // Create a print window
        const printWindow = window.open('', '', 'width=800,height=600');
        printWindow.document.write('<html><head><title>Lot Size Report</title>');
        printWindow.document.write('<style>body { font-family: Arial, sans-serif; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<h1>Lot Size Report</h1>');
        printWindow.document.write(tableHtml); // Insert the table
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for the document to load

        // Trigger the print dialog after content is loaded
        printWindow.print();
    };

    const handleDownloadImage = () => {
        if (!lotSizeData || lotSizeData.length === 0) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        const dataToExport = lotSizeData?.map(item => ([
            item.LotSizeProcedure || "NA",
            item.LS || "NA",
            item.LI || "NA",
            item.PDS || "NA",
            item.LLP || "NA",
            item.LLI || "NA",
            item.LPER || "NA",
            item.Description || "NA",
        ])) || [];

        const headers = [
            "LOT SIZE PROCEDURE", "LS", "LI", "Pds", "LLP", "LLI", "Lper", "DESCRIPTION",
        ];

        // Create the table HTML to be rendered
        let tableHtml = `
                                <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                                    <thead>
                                        <tr>
                                            ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        ${dataToExport.map(row => `
                                            <tr>
                                                ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                                            </tr>
                                        `).join('')}
                                    </tbody>
                                </table>
                            `;

        // Create a container div for the table to be captured
        const printContainer = document.createElement('div');
        printContainer.innerHTML = tableHtml;

        // Append the print container to the body (for rendering purposes)
        document.body.appendChild(printContainer);

        // Use html2canvas to convert the table HTML into an image
        html2canvas(printContainer, {
            scale: 2, // Increase the scale to get better image quality (default is 1)
            useCORS: true, // Enable Cross-Origin Resource Sharing (useful if the table includes external images)
            width: printContainer.scrollWidth, // Dynamically set the width of the canvas to fit the content
            height: printContainer.scrollHeight, // Dynamically set the height of the canvas to fit the content
            scrollX: 0, // Ensure that it doesn't pick up the page's scroll position
            scrollY: -window.scrollY // Adjust the scroll position if necessary
        }).then(canvas => {
            // Remove the print container after rendering
            document.body.removeChild(printContainer);

            // Convert canvas to image data URL
            const imgData = canvas.toDataURL('image/png');

            // Create a temporary link to trigger download
            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'lot_size_report.png'; // Specify the image file name
            link.click(); // Simulate a click event to trigger the download
        });
    };

    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        lotSizeDatas();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        showDownloadDropdown={true}
                        moduleName="Standards Master"
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Lot Size</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={4} className='filters-col'>
                                    <div className='customermanagement-search'>
                                        <Form.Control
                                            type="search"
                                            placeholder='Search'
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <img src={searchIcon} alt="" onClick={handleSearchClick} />
                                    </div>
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {/* {moduleData?.CanCreate === true && */}
                                <SbDropdownButton
                                    // pageName="Material Group"
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />
                                {/* } */}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <LotSizeTable
                                handleOpenModal={handleOpenModal}
                                handleOpenViewModal={handleOpenViewModal}
                                lotSizeData={lotSizeData}
                                selectedColumns={selectedColumns}
                                loading={loading}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                moduleData={moduleData}
                                totalDataCount={totalDataCount}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddLotSize
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    lotSizeID={lotSizeID}
                    singleLotSizeData={singleLotSizeData}
                    lotSizeDatas={lotSizeDatas}
                />
            }
            {
                showBulkUploadModal && <LotSizeBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                // deptData={deptData}
                />
            }
            {showColumnFilterModal && (
                <LotSizeColumnFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {/* {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )} */}
            {showViewDetails && (
                <ViewLotSizeModal
                    showViewDetails={showViewDetails}
                    handleCloseViewModal={handleCloseViewModal}
                    singleLotSizeData={singleLotSizeData}
                />
            )}
        </div >
    );
};

export default LotSize;